import type { UserEntity } from "@/shared/types/user.entity";
import {
  PUBLIC_ACCOUNTS_READ_SCOPES,
  PUBLIC_ACCOUNTS_ADD_SCOPES,
  PUBLIC_ACCOUNTS_EDIT_SCOPES,
  PUBLIC_ACCOUNTS_DELETE_SCOPES,
} from "../constants/public-accounts.constants";

export function canSeePublicAccounts(
  user: UserEntity | null | undefined
): boolean {
  if (!user?.scopes?.length) return false;
  return PUBLIC_ACCOUNTS_READ_SCOPES.some((scope) => user.scopes.includes(scope));
}

export function canAddPublicAccount(
  user: UserEntity | null | undefined
): boolean {
  if (!user?.scopes?.length) return false;
  return PUBLIC_ACCOUNTS_ADD_SCOPES.some((scope) => user.scopes.includes(scope));
}

export function canEditPublicAccount(
  user: UserEntity | null | undefined
): boolean {
  if (!user?.scopes?.length) return false;
  return PUBLIC_ACCOUNTS_EDIT_SCOPES.some((scope) => user.scopes.includes(scope));
}

export function canDeletePublicAccount(
  user: UserEntity | null | undefined
): boolean {
  if (!user?.scopes?.length) return false;
  return PUBLIC_ACCOUNTS_DELETE_SCOPES.some((scope) =>
    user.scopes.includes(scope)
  );
}

export function canSeePublicAccountsTracking(
  user: UserEntity | null | undefined
): boolean {
  if (!user?.scopes?.length) return false;
  return PUBLIC_ACCOUNTS_ADD_SCOPES.some((scope) => user.scopes.includes(scope));
}
